<ig-data-table
  [tableStyle]="tableStyle"
  [jsHoverDisabled]="true"
  
  [columns]="columns"
  [data]="(accounts$ | async) || []"
  [total]="(meta$ | async)?.total || 0"
  [meta$]="meta$"

  [search]="searchTerm"
  [searchBy]="'name'"

  [showFavorite]="false"
  [(selection)]="selection"

  [fixedHeader]="true"
  [fixedFirstColumn]="true"
  [fixedLastColumn]="false"

  [itemPlural]="'accounts' | translate"

  [loading]="!!(loading$ | async) && !(isLoadingNext$ | async)"
  [loadingNext]="!!(isLoadingNext$ | async)"
  (loadNext)="onLoadNext()"
  
  (selectionChange)="checker()"
  (doSearch)="onFilter($event)">
</ig-data-table>
